/**
 * API version for tokens endpoints
 */
export const TOKENS_API_VERSION = 'v2025-08-18'
